<template>
<section>
  <ul class="tab-control tabbed-nav">
    <li v-for="(tab, index) in tabs"
        :key="index"
        @click="selectTab(tab)">
      <a :class="{ 'current-section': tab.selected }">
        {{ tab.label }}
      </a>
    </li>
  </ul>
  <slot class="tabbed-content"></slot>
</section>
</template>

<script>
export default {
  data () {
    return {
      tabs: [],
      selectedTabId: null
    }
  },
  computed: {
    selectedTab () {
      return this.tabs.find(tab => tab.label === this.selectedTabId)
    }
  },
  methods: {
    addTab (tab) {
      this.tabs.push(tab)
    },
    selectTab (tab) {
      this.selectedTabId = tab.label
    },
    removeTab (tab) {
      this.tabs.splice(this.tabs.indexOf(tab), 1)
    }
  },
  mounted () {
    if (this.tabs.length > 0) {
      this.selectedTabId = this.tabs[0].label
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Widgets/ChcTabControl.vue